import React from 'react';

const IconMessage = ({ onClick, color = '#141029' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24" onClick={onClick}>
    <defs>
      <path id="prefix__amessage" d="M9 0c4.97 0 9 3.582 9 8 0 1.909-.752 3.661-2.007 5.036.005.096.007.193.007.29V16c0 .552-.448 1-1 1h-.48c-1.337 0-2.578-.44-3.581-1.186C10.315 15.936 9.666 16 9 16c-4.97 0-9-3.582-9-8s4.03-8 9-8zm5 13.325c0-.064-.002-.13-.005-.196l-.038-.829.559-.612C15.478 10.634 16 9.348 16 8c0-3.258-3.085-6-7-6S2 4.742 2 8s3.085 6 7 6c.53 0 1.05-.05 1.555-.15l.869-.17.71.53c.547.408 1.186.668 1.866.756v-1.64z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" />
      <g transform="translate(3 3)">
        <mask id="prefix__bmessage" fill="#fff">
          <use xlinkHref="#prefix__amessage" />
        </mask>
        <use fill={color} fillRule="nonzero" xlinkHref="#prefix__amessage" />
        <g mask="url(#prefix__bmessage)">
          <path d="M0 0H24V24H0z" transform="translate(-3 -3)" />
        </g>
      </g>
    </g>
  </svg>

);

export default IconMessage;
